import { updateService } from "../HttpService";

export const updatePharmacist = (id, formData) => {
  return updateService(`pharmacists/${id}`, {}, formData);
};
